import { render, staticRenderFns } from "./WrongPage.vue?vue&type=template&id=22ac636a&scoped=true"
import script from "./WrongPage.vue?vue&type=script&lang=ts"
export * from "./WrongPage.vue?vue&type=script&lang=ts"
import style0 from "./WrongPage.vue?vue&type=style&index=0&id=22ac636a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac636a",
  null
  
)

export default component.exports